(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var burger = document.getElementById('bb-burger');
    var closeBtn = document.getElementById('bb-mobile-close');
    var nav = document.getElementById('bb-mobile-nav');
    if (!burger || !nav) return;

    burger.addEventListener('click', function() {
      nav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        nav.classList.remove('open');
        document.body.style.overflow = '';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-topbar"] && !Shopify.designMode) return;
  try {
    
  /* VAT toggle — visual only for now; the price logic comes in a later stage */
  (function() {
    var vat = document.getElementById('bb-vat');
    if (!vat) return;
    vat.addEventListener('click', function() {
      var mode = vat.getAttribute('data-vat-mode');
      vat.setAttribute('data-vat-mode', mode === 'ex' ? 'inc' : 'ex');
      try { localStorage.setItem('bb_vat_mode', vat.getAttribute('data-vat-mode')); } catch(e){}
    });
    /* restore previous choice */
    try {
      var saved = localStorage.getItem('bb_vat_mode');
      if (saved) vat.setAttribute('data-vat-mode', saved);
    } catch(e){}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
